import Lookup from 'src/componentes/select2';

const Pais = (props) => (
  <Lookup labelKey="descricao" valueKey="id" url="/PaisItemLookup" {...props} />
);

export default Pais;
